import dayjs from 'dayjs'
import Link from 'next/link'
import React from 'react'
import styled from 'styled-components'
import { Avatar } from 'lib/Avatar'
import { Text } from 'lib/Text'

const Container = styled.div`
  display: flex;
`

const Anchor = styled.a`
  text-decoration: none;
  display: inline-flex;
`

const Name = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`

const AuthorAvatar = styled(Avatar)`
  margin-right: 12px;
`

const PublishDate = styled.time`
  &::before {
    align-self: center;
    content: '-';
    font-size: 10px;
    margin: 0 8px;
    position: relative;
    top: -2px;
  }
`

interface Props {
  name?: string | null
  title?: string | null
  imageUrl?: string | null
  className?: string
  contentPublishedAt?: string
  username?: string
}
export const StoryAuthor = ({ name, title, imageUrl, contentPublishedAt, className, username }: Props) => {
  const content = (
    <>
      <AuthorAvatar imageUrl={imageUrl} size="medium" />
      <Name>
        <Text as="h3" weight="semi" size="s">
          {name}
        </Text>
        <Text weight="regular" size="pxs">
          {title}
          {contentPublishedAt && (
            <PublishDate dateTime={dayjs(contentPublishedAt).format('YYYY-MM-DD')}>{dayjs(contentPublishedAt).format('MMMM D, YYYY')}</PublishDate>
          )}
        </Text>
      </Name>
    </>
  )

  if (username) {
    return (
      <Container className={className}>
        <Link legacyBehavior href={`/${username}/reviews`} passHref prefetch={false}>
          <Anchor>{content}</Anchor>
        </Link>
      </Container>
    )
  }

  return <Container className={className}>{content}</Container>
}
